// src/admin/context/AdminLanguageContext.js
import React, { createContext, useEffect, useState } from "react";

export const AdminLanguageContext = createContext();

export function AdminLanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("admin-lang");
      if (stored === "EN" || stored === "AR") return stored;
    }
    return "EN";
  });

  const toggleLanguage = () => {
    setLang((prev) => (prev === "EN" ? "AR" : "EN"));
  };

  useEffect(() => {
    const adminRoot = document.getElementById("admin-root");
    if (adminRoot) adminRoot.dir = lang === "AR" ? "rtl" : "ltr";

    localStorage.setItem("admin-lang", lang);
  }, [lang]);

  return (
    <AdminLanguageContext.Provider value={{ lang, toggleLanguage }}>
      {children}
    </AdminLanguageContext.Provider>
  );
}
